import { combineReducers } from "@reduxjs/toolkit";
import entitiesReducer from "./entities";
import authentication from "./auth";
import { apiSlice } from "./apiSlice";

export default combineReducers({
    entities: entitiesReducer,
    auth: authentication,
    [apiSlice.reducerPath]: apiSlice.reducer
});
